import { render, staticRenderFns } from "./Staging-New-360-Request-Step2.vue?vue&type=template&id=f04b0e20&scoped=true&"
import script from "./Staging-New-360-Request-Step2.vue?vue&type=script&lang=js&"
export * from "./Staging-New-360-Request-Step2.vue?vue&type=script&lang=js&"
import style0 from "./Staging-New-360-Request-Step2.vue?vue&type=style&index=0&id=f04b0e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04b0e20",
  null
  
)

export default component.exports